import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  friendlyName: PropTypes.string.isRequired,
});
